<section class="section-inset-y">
  @let contentType = contentType$ | async;
  <div class="container">
    <h1 class="h2">
      <small class="text-primary">{{ contentType | titlecase }}</small>
      {{ contentType + '-overzicht-titel' | fromDictionary }}
    </h1>
    <p class="text-max-width-xs">
      {{ contentType + '-overzicht-intro-tekst' | fromDictionary }}
    </p>

    <ul class="row mt-3 mt-sm-5 mt-md-8 bg-blob bg-blob--overview">
      @for (item of items$(); track item) {
        <li class="col-sm-6 mb-3 col-lg-4 d-flex">
          <app-card
            [title]="item.title || asAny(item).name"
            [link]="['/', contentType, item.id, asAny(item)['name'] || item.title | urlRewrite]"
            [date]="asAny(item)['publishDate']"
            [endDate]="asAny(item)['endDate']"
            [author]="contentType === 'blogs' ? asAny(item).author : null"
            [text]="contentType === 'blogs' || contentType === 'nieuws' ? (asAny(item)['intro'] || item.text | stripHtml | truncate: 150) : null"
            [showDate]="contentType === 'evenementen'"
            [showTime]="contentType === 'evenementen'"
            [imageUrl]="item.imageUrl"
            [imageAnchor]="asAny(item)?.['imageAnchor']"
            [videoUrl]="asAny(item)['videoUrl']"
          ></app-card>
        </li>
      }
    </ul>
  </div>
  @if ((page$()!.pageCount || 0) > 0) {
    <app-pagination [pages]="pages$()" [page]="page$()!"></app-pagination>
  }
</section>
